import React, { useEffect, useState } from 'react';
import { GiftIcon, TagIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { trackPurchaseClick } from '../utils/MetaPixel';
export const Bonuses = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const bonusBooks = [{
    title: 'Plan de 28 días para bajar grasa',
    description: 'Rutina completa de 4 semanas con +60 recetas en menos de 15 min.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uqE5cnJx6foTN5BvqfrPjb/9b8a0b39-ef92-40ac-82d2-1be471093a6b.png',
    price: 47
  }, {
    title: 'Postres fit en airfryer',
    description: 'Dulces saludables con menos calorías y el mismo sabor irresistible.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uViQDKEXmovMvwfC7FUVT6/081e9866-bd6a-4200-ac97-a26e53890e69.png',
    price: 47
  }, {
    title: 'Salsas y aderezos fit',
    description: 'Potencia el sabor de tus comidas sin sumar calorías innecesarias.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rMQrMTd9xn9EU7qgD9NaYB/Google_AI_Studio_2025-09-30T18_42_21.051Z.png',
    price: 47
  }, {
    title: 'Luncheras y freezer: 30 combos',
    description: 'Para oficina, escuela y post-entrenamiento: soluciones prácticas para llevar.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aUbzvXKXhNBkyJUQ2QGjgf/Google_AI_Studio_2025-09-30T18_46_16.191Z.png',
    price: 47
  }, {
    title: 'Ahorro pro en el Supermercado',
    description: 'Guía para comprar inteligente y reducir el gasto semanal en comida.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bTMX7ysU5FknnboapcjWp7/Google_AI_Studio_2025-09-30T18_50_09.939Z.png',
    price: 47
  }, {
    title: 'Especial Kids',
    description: 'Nuggets, bastoncitos y mini tartas que se comen sin protestar.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eiLZQaNzD2yyKx2qXEoqTJ/bbceed49-de14-4f4e-a089-f3d09f1d75d3.png',
    price: 47
  }];
  const totalValue = bonusBooks.reduce((sum, book) => sum + book.price, 0) + 47; // Adding main recipe book price
  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % bonusBooks.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? bonusBooks.length - 1 : prevIndex - 1);
  };
  useEffect(() => {
    if (autoPlay) {
      const interval = setInterval(() => {
        nextSlide();
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [autoPlay, currentIndex]);
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-teal-50 to-white" data-id="element-28">
      <div className="max-w-7xl mx-auto" data-id="element-29">
        <div className="text-center mb-10" data-id="element-30">
          <div className="inline-flex items-center justify-center bg-teal-100 text-teal-800 px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-31">
            <GiftIcon className="h-4 w-4 mr-2" data-id="element-32" />
            <span data-id="element-33">6 BONOS EXCLUSIVOS</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-34">
            Consigue todo lo que necesitas por el precio de uno
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-35">
            Hoy llevas el recetario + 6 bonos. Valor total{' '}
            <span className="line-through" data-id="element-36">$329 USD</span>{' '}
            <span className="text-teal-700 font-bold" data-id="element-37">HOY SOLO $17 USD</span>
          </p>
        </div>
        <div className="relative max-w-md mx-auto mb-10 md:mb-16" onMouseEnter={() => setAutoPlay(false)} onMouseLeave={() => setAutoPlay(true)} data-id="element-38">
          <div className="overflow-hidden rounded-xl shadow-xl bg-white p-4" data-id="element-39">
            <div className="relative aspect-square flex items-center justify-center" data-id="element-40">
              <img src={bonusBooks[currentIndex].image} alt={bonusBooks[currentIndex].title} className="object-contain max-h-full max-w-full transition-opacity duration-300" data-id="element-41" />
            </div>
            <div className="mt-4 text-center" data-id="element-42">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-43">
                {bonusBooks[currentIndex].title}
              </h3>
              <p className="text-gray-600 mt-1" data-id="element-44">
                {bonusBooks[currentIndex].description}
              </p>
              <div className="mt-2" data-id="element-45">
                <span className="inline-block bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-46">
                  Valor:{' '}
                  <span className="line-through" data-id="element-47">
                    ${bonusBooks[currentIndex].price} USD
                  </span>
                  <span className="block font-bold" data-id="element-48">hoy gratis</span>
                </span>
              </div>
            </div>
          </div>
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none" aria-label="Anterior bono" data-id="element-49">
            <ChevronLeftIcon className="h-6 w-6 text-gray-600" data-id="element-50" />
          </button>
          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none" aria-label="Siguiente bono" data-id="element-51">
            <ChevronRightIcon className="h-6 w-6 text-gray-600" data-id="element-52" />
          </button>
          <div className="flex justify-center mt-4 gap-2" data-id="element-53">
            {bonusBooks.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2.5 w-2.5 rounded-full transition-colors duration-200 ${index === currentIndex ? 'bg-teal-600' : 'bg-gray-300'}`} aria-label={`Ver bono ${index + 1}`} data-id="element-54" />)}
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-lg max-w-3xl mx-auto" data-id="element-55">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-56">
            <div data-id="element-57">
              <div className="flex items-center mb-2" data-id="element-58">
                <TagIcon className="h-5 w-5 text-teal-600 mr-2" data-id="element-59" />
                <p className="font-semibold text-gray-900" data-id="element-60">
                  Oferta por tiempo limitado
                </p>
              </div>
              <div className="text-gray-700 mb-1" data-id="element-61">
                <span className="font-bold" data-id="element-62">Recetario + 6 Bonos:</span>{' '}
                <span className="line-through text-gray-500" data-id="element-63">
                  ${totalValue} USD
                </span>
              </div>
              <div className="text-2xl font-bold text-teal-700" data-id="element-64">
                Hoy: $17 USD
              </div>
            </div>
            <div className="w-full sm:w-auto" data-id="element-65">
              <a href="https://organicecomm.com/cart/51818275930293:1" className="block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-center w-full" onClick={trackPurchaseClick} data-id="element-66">
                Quiero mi recetario por $17 USD
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};